<div class="display-layout-column layout-gap-15">

  <div class="display-layout-row display-flex">
    <div class="headline align-items-center">
      <span>Requests</span>

      <button mat-icon-button matTooltip="Refresh" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>

      <button mat-icon-button matTooltip="Export as Excel" (click)="exportRequests()">
        <mat-icon>save_alt</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider ></mat-divider>


  <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)" animationDuration="0ms">
    <mat-tab >
      <ng-template mat-tab-label>
        @if (this.getNewOpenCountMessages() > 0) {
          <span matBadge="{{this.getNewOpenCountMessages()}}"
          matBadgeColor="accent" matBadgeOverlap="false">{{getOpenHeader()}}</span>
        }
        @if (this.getNewOpenCountMessages() == 0) {
          <span>{{getOpenHeader()}}</span>
        }
      </ng-template>
      <div >
        <open-requests></open-requests>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        @if (this.getNewInvoiceCountMessages() > 0) {
          <span matBadge="{{this.getNewInvoiceCountMessages()}}"
          matBadgeColor="accent" matBadgeOverlap="false">{{getInvoiceHeader()}}</span>
        }
        @if (this.getNewInvoiceCountMessages() == 0) {
          <span>{{getInvoiceHeader()}}</span>
        }
      </ng-template>
      <div>
        <invoice-requests></invoice-requests>
      </div>
    </mat-tab>
    <mat-tab label="">
      <ng-template mat-tab-label>
        @if (this.getNewClosedCountMessages() > 0) {
          <span matBadge="{{this.getNewClosedCountMessages()}}"
          matBadgeColor="accent" matBadgeOverlap="false">{{getClosedHeader()}}</span>
        }
        @if (this.getNewClosedCountMessages() == 0) {
          <span>{{getClosedHeader()}}</span>
        }
      </ng-template>
      <div>
        <closed-requests></closed-requests>
      </div>
    </mat-tab>
    <mat-tab label="Not Assigned Messages">
      <div>
        <not-assigned-messages></not-assigned-messages>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
